import { ActionTree } from 'vuex';

export default <ActionTree<home.state.HomeState, RootState>>{
};
